import axios from "axios";
import { GURL } from "./global";

export const GetPositionByParentId = (ParentId: any) => {
  const url = `${GURL}/company/v1/Position/GetPositionByParentId?ParentId=${ParentId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetUnderLayingPositions = () => {
  const url = `${GURL}/company/v1/position/GetUnderLayingPositions`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetPositionById = (Id: any) => {
  const url = `${GURL}/Company/v1/Position/GetPositionById?Id=${Id}`;
  //console.log(url);
  return axios.get(url);
};

export const DeletePositionByUserIdAndAddNewPosition = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(
    `${GURL}/Company/v1/Position/DeletePositionByUserIdAndAddNewPosition`,
    f
  );
};

export const UpdatePosition = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Company/v1/Position/Update`, f);
};

export const DeletePositionService = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Company/v1/Position/DeletePosition`, f);
};

export const GetPositionByUser = () => {
  const url = `${GURL}/Company/v1/Position/GetPositionByUser`;
  //console.log(url);
  return axios.get(url);
};

export const GetPositionByUserId = (userId: string) => {
  const url = `${GURL}/Company/v1/Position/GetPositionByUserId?UserId=${userId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetAllPositions = () => {
  const url = `${GURL}/company/v1/position`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyPosition = () => {
  //console.log(`Bearer ${localStorage.getItem("token")}`);

  const url = `${GURL}/company/v1/position/GetMyPosition`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetAllEmptyPositions = () => {
  const url = `${GURL}/company/v1/position/GetAllEmptyPositions`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetPositionRoleByPositionIdAndRole = (
  positionId: string,
  roleKey: string
) => {
  const url = `${GURL}/Company/v1/Position/GetPositionRoleByPositionIdAndRole?PositionId=${positionId}&RoleKey=${roleKey}`;
  //console.log(url);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetPositionsTreeByCompanyId = () => {
  const url = `${GURL}/Company/v1/Position/GetPositionsTreeByCompanyId`;
  //console.log(url);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
